export type Reminder = {
  id: number;
  userId: string;
  name: string;
  title: string;
  message: string;
  frecuency: number;
  frecuencyType: number;
  automaticAssign: boolean;
  toActivateFrecuency?: number;
  toActivateFrecuencyType?: number;
};

export interface ReminderMixin {
  fetch(path: string, init?: RequestInit): Promise<any>;
  getReminders(): Promise<Reminder[]>;
  createReminder(reminder: Omit<Reminder, 'id' | 'userId' | 'automaticAssign'>): Promise<Reminder>;
  updateReminder(reminder: Partial<Omit<Reminder, 'id'>> & { id: number }): Promise<Reminder>;
  deleteReminder(id: number): Promise<any>;
}
export const ReminderMixin = {
  async fetch(path: string, init?: RequestInit): Promise<any> {
    throw new Error('Not implemented');
  },
  async getReminders(): Promise<Reminder[]> {
    const res = await this.fetch(`/reminders`, { method: 'get' });
    return res;
  },
  async createReminder(reminder: Omit<Reminder, 'id' | 'userId'>): Promise<Reminder> {
    const res = await this.fetch(`/reminders`, {
      method: 'post',
      body: JSON.stringify({ ...reminder }),
    });
    return res;
  },
  async updateReminder(
    reminder: Partial<Omit<Reminder, 'id'>> & { id: number }
  ): Promise<Reminder> {
    const res = await this.fetch(`/reminders/${reminder.id}`, {
      method: 'put',
      body: JSON.stringify({ ...reminder }),
    });
    return res;
  },
  async deleteReminder(id: number): Promise<any> {
    const res = await this.fetch(`/reminders/${id}`, { method: 'delete' });
    return res;
  },
} as ReminderMixin;
